module.exports = __webpack_public_path__ + "static/screen-classic-laptop@2x-684e35a0d91aa330826a1e7f7a04a4d9.png";